var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: _vm.collapsible_classes },
    [
      !_vm.routesEmpty()
        ? _c("li", { staticClass: "hr-sect" }, [
            _vm._v(_vm._s(_vm.main_link_title))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.routesToDo, function(route) {
        return _c("li", [
          route.hasOwnProperty("children")
            ? _c(
                "a",
                { staticClass: "collapsible-header waves-effect arrow-r" },
                [
                  _c("i", { staticClass: "fa", class: route.icon }),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(route.title))
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.log("route", route)) +
                      "\n            "
                  ),
                  _c("i", { staticClass: "fa fa-angle-down rotate-icon" })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          route.hasOwnProperty("children")
            ? _c("div", { staticClass: "collapsible-body" }, [
                _c(
                  "ul",
                  { staticClass: "sub-menu" },
                  _vm._l(route.children, function(child_route) {
                    return _c("li", { staticClass: "is_child" }, [
                      _c("a", { attrs: { href: child_route.route } }, [
                        _c("i", { staticClass: "fa", class: child_route.icon }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-capitalize" }, [
                          _vm._v(_vm._s(child_route.title))
                        ])
                      ])
                    ])
                  })
                )
              ])
            : _c("div", [
                _c("a", { attrs: { href: route.route } }, [
                  _c("i", { staticClass: "fa", class: route.icon }),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(route.title))
                  ])
                ])
              ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f35fb1f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f35fb1f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/navigation/sideNavigation.vue
// module id = 425
// module chunks = 0